import { render, staticRenderFns } from "./ExamPaperList.vue?vue&type=template&id=3abef3f2"
import script from "./ExamPaperList.vue?vue&type=script&lang=js"
export * from "./ExamPaperList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports